import { useGetBusinessUnitByIdQuery } from '@xemplo/business-unit-query';
import { InlineBanner, InlineBannerType } from '@xemplo/inline-banner';

export function TimezoneBanner(props: { businessUnitId: string }) {
  const { data } = useGetBusinessUnitByIdQuery({
    id: props.businessUnitId,
  });
  const timezone = data?.result.operatingTimeZone;
  return (
    <InlineBanner
      title="All dates are presented in Business Unit time zone"
      subTitle={timezone ? `(${timezone})` : undefined}
      type={InlineBannerType.Warning}
    />
  );
}
